<template>
  <lazy-cms-video-cloudinary-player
    v-if="$feature.enableCloudinaryVideoPlayer && content.cloudinaryAsset?.publicId"
    v-bind="content"
  />
  <cms-video-player
    v-else
    :content="{
      id: content.id,
      type: content.type,
      media: { sm: content },
      playerSettings: {
        autoplay: true,
        hideControls: false,
        loop: true,
        muted: true,
      },
    }"
  />
</template>

<script lang="ts" setup>
import type { CMSVideo } from '#types/media'

const { content } = defineProps<{ content: CMSVideo }>()
</script>
